/**
 * @generated SignedSource<<b45f66040caa98893b4341fbd52aab35>>
 * @relayHash 2815df7bd24478af405e386150e5dffc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 701a662bba71ac50851531972420f1d84c874fd8a302e3058e44ff71e36836d7

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiSupportWebsiteOverviewServiceHubPageQuery } from './uiSupportWebsiteOverviewServiceHubPageQuery.graphql';

const node: PreloadableConcreteRequest<uiSupportWebsiteOverviewServiceHubPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "701a662bba71ac50851531972420f1d84c874fd8a302e3058e44ff71e36836d7",
    "metadata": {},
    "name": "uiSupportWebsiteOverviewServiceHubPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
